package org.braunequip.web.components.models

import kotlinx.serialization.Serializable

@Serializable
data class EquipRepairRequestDTO(
    var id: Int? = null,
    var firstName: String = "",
    var lastName: String = "",
    var date: String = "",           //LocalDate
    var tractorUnit: String = "",
    var tractorNeeds: String = "",
    var tractorService: Boolean = false,
    var trailerUnit: String = "",
    var trailerNeeds: String = "",
    var trailerService: Boolean = false,
    var createdAt: String? = null
)